<template>
  <div class="layout">
    <div class="layout_nav">
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <div class="layout_row">
        <div class="layout_colum">
          <Welcome v-bind="getUser"></Welcome>
        </div>
        <div class="layout_colum">
          <Snackbar
            v-bind:visible="getAlert.snackbar"
            v-bind:text="getAlert.text"
          ></Snackbar>
        </div>
      </div>
      <v-row class="report_cards_ctn">
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon> LECTURAS
              </p>
            </div>
            <div class="card_report_body">
              <p>
                Generar un reporte de lecturas de todos los dispositivos por periodo.
              </p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportReads()" plain>
                <span>
                  Generar
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon> LECTURAS
                DE DISPOSITIVO
              </p>
            </div>
            <div class="card_report_body">
              <p>
                Generar un reporte de lecturas de un dispositivo en especifico.
              </p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportDevice()" plain>
                <span>
                  Generar
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon> DISPOSITIVOS
                POR CLIENTE
              </p>
            </div>
            <div class="card_report_body">
              <p>Generar un reporte de todos los dispositivos del cliente.</p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportClient()" plain>
                Generar
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon> HISTORIAL DE
                DISPOSITIVO
              </p>
            </div>
            <div class="card_report_body">
              <p>
                Generar un reporte del historial de datos de un dispositivo.
              </p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportInvoice()" plain>
                <span>
                  Generar
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon>
                NOTIFICACIONES DE DISPOSITIVOS
              </p>
            </div>
            <div class="card_report_body">
              <p>
                Generar un reporte de las notificaciones generadas por los dispositivos.
              </p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportDevicesNotifications()" plain>
                <span>
                  Generar
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon> INTEGRADORES
                POR CLIENTE
              </p>
            </div>
            <div class="card_report_body">
              <p>Genera un reporte de Integradores disponibles del cliente.</p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportIntegrator()" plain>
                <span>
                  Generar
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="card_report">
            <div class="card_report_title">
              <p>
                <v-icon aria-hidden="false">mdi-file-chart</v-icon>
                DATOS DEL INTEGRADOR
              </p>
            </div>
            <div class="card_report_body">
              <p>
                Generar un reporte de los datos de un integrador especifico.
              </p>
            </div>
            <div class="card_report_footer">
              <v-btn @click="reportIntegratorRange()" plain>
                <span>
                  Generar
                </span>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <ReadsReport
      :visible="readsFlag"
      @close="readsFlag = false"
    ></ReadsReport>
    <ClientReport
      :visible="clientFlag"
      @close="clientFlag = false"
    ></ClientReport>
    <DeviceReport
      :visible="deviceFlag"
      @close="deviceFlag = false"
    ></DeviceReport>
    <InvoiceReport
      :visible="invoiceFlag"
      @close="invoiceFlag = false"
    ></InvoiceReport>
    <IntegratorReport
      :visible="integratorFlag"
      @close="integratorFlag = false"
    ></IntegratorReport>
    <IntegratorReportRange
      :visible="integratorRangeFlag"
      @close="integratorRangeFlag = false"
    ></IntegratorReportRange>
    <DevicesNotifications
      :visible="devicesNotifications"
      @close="devicesNotifications = false"
    ></DevicesNotifications>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Nav from '@/components/Nav.vue'
import Welcome from '@/components/Welcome.vue'
import Snackbar from '@/components/Snackbar.vue'
import ReadsReport from '@/components/reports/Reads.vue'
import ClientReport from '@/components/reports/Client.vue'
import DeviceReport from '@/components/reports/Device.vue'
import InvoiceReport from '@/components/reports/Invoice.vue'
import IntegratorReport from '@/components/reports/Integrator.vue'
import IntegratorReportRange from '@/components/reports/RangeIntegrator.vue'
import DevicesNotifications from '@/components/reports/Notifications.vue'
export default {
  name: 'ReportHome',
  components: {
    Nav,
    Welcome,
    Snackbar,
    ReadsReport,
    ClientReport,
    DeviceReport,
    InvoiceReport,
    IntegratorReport,
    IntegratorReportRange,
    DevicesNotifications,
  },
  data() {
    return {
      readsFlag: false,
      clientFlag: false,
      deviceFlag: false,
      invoiceFlag: false,
      integratorFlag: false,
      integratorRangeFlag: false,
      deviceRangeFlag: false,
      devicesNotifications: false,
    }
  },
  async created() {
    await this.listCompany()
  },
  methods: {
    ...mapActions(['listCompany']),
    reportReads() {
      this.readsFlag = true
    },
    reportClient() {
      this.clientFlag = true
    },
    reportDevice() {
      this.deviceFlag = true
    },
    reportInvoice() {
      this.invoiceFlag = true
    },
    reportIntegrator() {
      this.integratorFlag = true
    },
    reportIntegratorRange() {
      this.integratorRangeFlag = true
    },
    reportDevicesNotifications() {
      this.devicesNotifications = true;
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'getUser',
      'getAlert',
      'getRol',
      'getListCompany',
    ]),
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/base.scss';
.report_cards_ctn {
  margin: 0 2px;
  .card_report {
    display: flex;
    height: 100%;
    flex-direction: column;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: $transition-shadown;
    @media #{$phone-down} {
      margin-bottom: 20px;
    }
    &:hover {
      box-shadow: $shadow-1;
    }
    .card_report_title {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background-color: #181f1c;
      padding: 10px 15px;
      p {
        color: #fff;
        font-family: 'Roboto Condensed', sans-serif;
        margin-bottom: 0;
        i {
          color: $color-primary-1;
          padding-right: 5px;
        }
      }
    }
    .card_report_body {
      padding: 10px;
      p {
        font-size: 1rem;
        font-family: 'Roboto', sans-serif;
      }
    }
    .card_report_footer {
      display: flex;
      flex: 1;
      align-items: flex-end;
      justify-content: flex-end;
      margin: 1px;
      button {
        color: $blue-btn;
        &.v-btn--plain {
          .v-btn__content {
            opacity: 1 !important;
          }
        }
      }
    }
  }
}
</style>
